
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#fff","data-name":"vuesax/twotone/search-normal"}},[_c('path',{attrs:{"d":"M10.469 2.237a8.232 8.232 0 11-8.232 8.232 8.241 8.241 0 018.232-8.232zm0 14.964a6.732 6.732 0 10-6.732-6.732 6.74 6.74 0 006.732 6.732z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M21.014 21.763a.748.748 0 01-.53-.22l-3.062-3.062a.75.75 0 010-1.06.75.75 0 011.06 0l3.062 3.061a.75.75 0 01-.53 1.28z","opacity":".4"}})])])
          )
        }
      }
    